import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { RoleEnum } from 'src/api';

const RestrictedRoute = ({ to, children }) => {
	const { userRole } = useAuth();

	if (userRole === RoleEnum.ADMIN) {
		return <>{children}</>;
	}

	if (to.includes(userRole)) {
		return <>{children}</>;
	}

	return <Navigate to="/not-authorized" replace />;
};

export default RestrictedRoute;
